import {FormInstance} from 'antd/lib/form'
import GetCostRequestInterface from '../types/requests/get-cost'
import GlobalOptionsInterface from '../types/global-options'
import IDS from '../constants/ids'
import RequestCallbackInterface from '../types/requests/request-callback'

/*
    В функциях этого класса мы не проверяем
    на наличие корректных значений полей,
    это задача валидатора.
    Мы просто берем значения из полей.
 */
class Extractor {
    private form: FormInstance
    private globalOptions: GlobalOptionsInterface

    setForm = form => (this.form = form)
    setGlobalOptions = globalOptions => (this.globalOptions = globalOptions)

    extractDataForGetCost = (): GetCostRequestInterface => {
        // log('extractDataForGetCost', this.form.getFieldsValue())
        const {getFieldValue} = this.form,
            insSum = parseInt(getFieldValue(IDS.INSURANCE_SUM)),
            franchise = getFieldValue(IDS.FRANCHISE),
            program = getFieldValue(IDS.INSURANCE_TYPE),
            cargoType = getFieldValue(IDS.CARGO_TYPE),
            loadingType = getFieldValue(IDS.CARGO_LOADING_TYPE),
            longDelivery = getFieldValue(IDS.TRANSPORT_LONG_DELIVERY)

        let distanceArea = getFieldValue(IDS.DISTANCE_AREA),
            packaging = getFieldValue(IDS.CARGO_PACKAGING),
            distanceCount = getFieldValue(IDS.DISTANCE_COUNT),
            distanceFrom = getFieldValue(IDS.DISTANCE_FROM),
            distanceTo = getFieldValue(IDS.DISTANCE_TO),
            transportGuard = getFieldValue(IDS.TRANSPORT_GUARD),
            transportShipping = getFieldValue(IDS.TRANSPORT_SHIPPING),
            transportType: string[] = getFieldValue(IDS.TRANSPORT_TYPE),
            transportStorage = getFieldValue(IDS.TRANSPORT_STORAGE),
            loadingCount = getFieldValue(IDS.TRANSPORT_LOADING_COUNT)

        if (packaging && packaging.includes('#')) {
            packaging = packaging.slice(0, packaging.indexOf('#'))
            // приходится срезать часть строки, так с бэка приходят одинаковые code
        }

        let data: GetCostRequestInterface;
        data = {
            insSum,
            franchise,
            program: program ? program : 'A',
            cargoType: cargoType ? cargoType : 1,
            packaging: packaging ? packaging : 'wood',
            guard: transportGuard ? transportGuard : 'none',
            transports: transportType && transportType.length > 0 ? [...transportType] : ['car'],
            storage: transportStorage ? transportStorage : 0,
            distance: {
                area: distanceArea ? distanceArea : 'russia',
                count: distanceCount ? distanceCount : 1000,
            },
            shipping: transportShipping ? transportShipping : 'fullMetal',
            carMoreThan200: !!longDelivery,
            departure: distanceFrom ? distanceFrom : 'не указано',
            arrival: distanceTo ? distanceTo : 'не указано',
            beginDate: getFieldValue("beginDate")?.format('YYYY-MM-DD') ?? null,
            endDate: getFieldValue("endDate")?.format('YYYY-MM-DD') ?? null,
            onTheRoad: !!getFieldValue("onTheRoad"),
        };

        if (loadingCount && parseInt(loadingCount) !== 0) {
            data.loading = {
                type: loadingType ? loadingType : 'dimension',
                count: loadingCount,
            }
        }

        if (!data.loading && loadingType) {
            data.departure = `${
                distanceFrom ? distanceFrom : 'не указано'
            } (габаритность:${loadingType})`
        }

        if (this.globalOptions && this.globalOptions.userIsn) {
            data.userIsn = this.globalOptions.userIsn
        } else {
            data.userIsn = 0
        }

        return data
    }

    extractDataForRequest = (): RequestCallbackInterface => {
        const {getFieldValue} = this.form
        const insurerData = getFieldValue('insurer')
        if (insurerData.hasOwnProperty('birthday')) {
            insurerData.birthday = insurerData.birthday.format('YYYY-MM-DD')
        }

        return {
            partner: this.globalOptions.code,
            insurer: {...insurerData}
        }
    }
}

const extractor = new Extractor()

export default extractor
